import React, { Component, Fragment } from 'react';
import moment from 'moment';
import NotificationSystem from 'react-notification-system';
import { getSchoolYearOptions } from '../../../server/utilDistrict';
import SamplingPoolSelection from './samplingPoolSelection';
import MasterTrackingLog from './masterTrackingLog';
import IndividualTrackingForms from './individualTrackingForms';
import FNSCollectionReport from './fNSCollectionReport';
import CorrespondenceLetterLog from './correspondenceLetterLog';
import ExportAll from './exportAll';
import ReactTable from 'react-table';
import { get } from '../../../server/actions';
import { groupBy, showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import './verification.css';
import { Modal } from 'react-bootstrap';

const formatSchoolYear = (y) => `${y}-${(y + 1).toString().slice(-2)}`;

const Verification_REPORT_COMPONENTS = [
   SamplingPoolSelection,
   MasterTrackingLog,
   IndividualTrackingForms,
   FNSCollectionReport,
   CorrespondenceLetterLog,
   ExportAll,
];

class VerificationReports extends Component {
    constructor(props) {
        super(props);
        const schoolYearOptions = getSchoolYearOptions();
        const activeSchoolYear = schoolYearOptions[0];
        const currentSchoolYear = schoolYearOptions[0];
        this.state = {
            activeSchoolYear,
            selectedSchoolYear: activeSchoolYear,
            schoolYearOptions,
            verifiedApplications: [],
            verifiedSearch: "",
            userInfo: getLoginDistrictInfo(),
            cycleData: null,
            verifiedSearch: " ",
            // For debounced search
            searchTimeout: null,
            showVerificationDetailsModal: false,
            verificationDetails: {
                documents: [],
                history: [],
                annotations: [],
                correspondence: []
            },
        };
    };

    componentDidUpdate = (prevProps, prevState) => {
    const schoolChanged = prevProps.selectSchool !== this.props.selectSchool;
    const yearChanged = prevState.selectedSchoolYear !== this.state.selectedSchoolYear;
        if (schoolChanged || yearChanged) {
            this.getVerificationCyclesReport(this.state.selectedSchoolYear, this.props.selectSchool );
            this.getVerificationReportsList( this.state.selectedSchoolYear, this.state.verifiedSearch, this.props.selectSchool );
         }
    };

    componentWillMount = () => {
           this.props.changeShowHideSchoolFitler(true);
            if (this.state.searchTimeout) {
        clearTimeout(this.state.searchTimeout);
        }
     }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.getVerificationCyclesReport( this.state.selectedSchoolYear, this.props.selectSchool );
        this.getVerificationReportsList( this.state.selectedSchoolYear, this.state.verifiedSearch, this.props.selectSchool );
    };

   getVerificationReportsList = ( verificationYear = this.state.selectedSchoolYear, search = this.state.verifiedSearch, schoolID = this.props.selectSchool) => {
        const districtID = this.state.userInfo.districtId;
        this.setState({ loading: true });
        const trimmedSearch = search ? search.trim() : "";
        let url = `/verification/reports/records/${districtID}/${verificationYear}?`;
        // Add schoolId only when a valid school is selected
        const selectedSchoolId = parseInt(schoolID, 10);
        if (selectedSchoolId > 0) {
            url += `schoolId=${selectedSchoolId}&`;
        }
        // Add search only when entered
        if (trimmedSearch) {
            url += `search=${encodeURIComponent(trimmedSearch)}&`;
        }
        // access token
        url += `access_token=`;
        get(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then((data) => {
            this.setState({ verifiedApplications: data || [],
                            loading: false });
        })
        .catch((error) => {
            this.setState({ verifiedApplications: [],
                            loading: false });
            console.log( "Get verification reports response:", error);
        });
    };

    handleOpenApplication = ( row, schoolID = this.props.selectSchool ) => {
        const verifyId = row.verifyId;
        this.setState({ loading: true });
        let url = `/verification/reports/records/detail/${verifyId}?`;
        // Add schoolId only when a specific school is selected
        const selectedSchoolId = parseInt(schoolID, 10);
        if (selectedSchoolId > 0) {
            url += `schoolId=${selectedSchoolId}&`;
        }
            // Add access token
            url += `access_token=`;
            get(url).then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response.json();
                }).then(data => {
            this.setState({
                    verificationDetails: {
                    documents: data.documents || [],
                    history: data.history || [],
                    annotations: data.annotations || [],
                    correspondence: data.correspondence || []
                },
                showVerificationDetailsModal: true,
                loading: false
            });
        })
        .catch(error => {
            this.setState({loading: false });
            console.log('Get verification details response:', error );
        });
    };

    closeVerificationDetailsModal = () => {
        this.setState({
        showVerificationDetailsModal: false
     });
   };

   getVerificationCyclesReport = ( verificationYear = this.state.selectedSchoolYear, schoolID = this.props.selectSchool) => {
        const districtID = sessionStorage.getItem('districtId');
        this.setState({ loading: true });
        let url = `/verification/reports/cycles/${districtID}?verificationYear=${verificationYear}&`;
        // Add schoolId only when a specific school is selected
        const selectedSchoolId = parseInt(schoolID, 10);
        if (selectedSchoolId > 0) {
            url += `schoolId=${selectedSchoolId}&`;
        }
            // Add access token
            url += `access_token=`;
            get(url).then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response.json();
                }).then(data => {
                const selectedCycle = (data || []).find(
                    item => item.verificationYear === verificationYear
                );
            this.setState({ cycleData: selectedCycle || null,
                           loading: false
                         });
            })
            .catch(error => {
                this.setState({ cycleData: null,
                                loading: false
                     });
                console.log('Get verification cycles response:', error );
            });
    };

    getEligibilityClass = (status) => {
        if (!status) return "";
        switch (status.toLowerCase()) {
            case "free":
                return "eligibility-free";
            case "reduced":
                return "eligibility-reduced";
            case "paid":
                return "eligibility-paid";
            default:
                return "";
        }
    };
    handleVerifiedSearch = (e) => {
        const search = e.target.value;
        this.setState({
            verifiedSearch: search
        });
        // Clear previous timeout
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }
        // Wait 500ms after user stops typing
        const timeout = setTimeout(() => {
            this.getVerificationReportsList(
                this.state.selectedSchoolYear,
                search, this.props.selectSchool
            );
        }, 500);
    this.setState({ searchTimeout: timeout});
   };
  getVerifiedApplicationColumns = () => [
    {
        Header: "Application",
        accessor: "applicationId",
        width: 500,
        sortable: false,
        filterable: false,
        Cell: row => {
            const app = row.original;

            return (
                <div className="verified-app-info">
                    <div className="verified-app-title">
                        Application {app.applicationId} - {app.guardianName}
                    </div>
                    <div className="verified-app-subtitle">
                        {app.completedDate && (
                            <Fragment>
                                Completed {moment(app.completedDate).format("MMM D, YYYY")}
                            </Fragment>
                        )}                       
                         {app.nonResponse ? " (non-response)" : ""}
                        {" - "}
                        {app.documentCount} documents
                        {" - "}
                        {app.letterCount} letters
                    </div>
                </div>
            );
        }
    },
    {
        Header: "Students",
        accessor: "studentNames"
    },
    {
        Header: "Eligibility",
        accessor: "eligibility",
        sortable: false,
        filterable: false,
        style: { textAlign: 'center'},
        Cell: row => {
            const app = row.original;
            return (
                <div className="eligibility-flow">
                    <span className={
                        `eligibility-badge ${this.getEligibilityClass(app.currentEligibility)}`
                    }>
                        {app.currentEligibility}
                    </span>
                    <span className="eligibility-arrow">
                        →
                    </span>
                    <span className={
                        `eligibility-badge ${this.getEligibilityClass(app.newEligibility)}`
                    }>
                        {app.newEligibility}
                    </span>
                </div>
            );
        }
    },
    {
        Header: "Action",
        accessor: "action",
        width: 70,
        sortable: false,
        filterable: false,
        style: {  textAlign: "center" },
        Cell: row => (
            <button
                type="button"
                className="verified-open-btn"
                onClick={() => this.handleOpenApplication(row.original)}
            >  Open
            </button>
        )
    }
];
    getDocumentColumns = () => [
        {
            Header: "Type",
            accessor: "inputType",
            width: 120,
            style: { textAlign: 'center' },
            Cell: ({ value }) => (
                <span className="label label-warning">
                    {value}
                </span>
            )
        },
        {
            Header: "Document",
            accessor: "documentDesc",
            width: 200,
            style: { textAlign: 'center' }
        },
        // {
        //     Header: "Notes",
        //     accessor: "notes",
        //     minWidth: 200,
        //     style: { textAlign: 'center' }
        // },
        {
            Header: "Created On",
            accessor: "createdOn",
            width: 200,
            style: { textAlign: 'center' },
            Cell: ({ value }) =>
                value ? moment(value).format("YYYY-MM-DD") : "-"
        },
        {
            Header: "Created By",
            accessor: "createdBy",
            width: 300,
            style: { textAlign: 'center' }
        }
    ];
    getHistoryColumns = () => [
        {
            Header: "Action",
            accessor: "action",
            width: 180,
            Cell: ({ value }) => (
                <span className="label label-primary">
                    {value}
                </span>
            )
        },
        {
            Header: "Previous Outcome",
            accessor: "previousOutcome",
            width: 150,
            Cell: ({ value }) => value || "-"
        },
        {
            Header: "New Outcome",
            accessor: "newOutcome",
            width: 150,
            Cell: ({ value }) => (
                <span className="label label-success">
                    {value || "-"}
                </span>
            )
        },
        {
            Header: "Previous Status",
            accessor: "previousEffectiveStatus",
            width: 150,
            Cell: ({ value }) => value || "-"
        },
        {
            Header: "New Status",
            accessor: "newEffectiveStatus",
            width: 150,
            Cell: ({ value }) => (
                <span className="label label-info">
                    {value || "-"}
                </span>
            )
        },
        {
            Header: "Action Date",
            accessor: "actionDate",
            width: 150,
            Cell: ({ value }) =>
                value ? moment(value).format("YYYY-MM-DD") : "-"
        },
        {
            Header: "Performed By",
            accessor: "performedBy",
            width: 150
        }
    ];
    getAnnotationColumns = () => [
        {
            Header: "Type",
            accessor: "inputType",
            width: 150,
            style: { textAlign: 'center' },
            Cell: ({ value }) => (
                <span className="label label-warning">
                    {value}
                </span>
            )
        },
        {
            Header: "Notes",
            accessor: "notes",
            width: 200,
            style: { textAlign: 'center' }
        },
        // {
        //     Header: "Document",
        //     accessor: "documentDesc",
        //     width: 200,
        //     style: { textAlign: 'center' },
        //     Cell: ({ value }) => value || "-"
        // },
        {
            Header: "Created On",
            accessor: "createdOn",
            style: { textAlign: 'center' },
            width: 200,
            Cell: ({ value }) =>
                value ? moment(value).format("YYYY-MM-DD") : "-"
        },
        {
            Header: "Created By",
            accessor: "createdBy",
            width: 300,
            style: { textAlign: 'center' }
        }
    ];
    getCorrespondenceColumns = () => [
        {
            Header: "Verify Id",
            accessor: "verifyId",
            width:200,
            style: { textAlign: 'center' }
        },
        {
            Header: "Communication Type",
            accessor: "communicationType",
            width: 200,
            style: { textAlign: 'center' },
            Cell: ({ value }) => (
                <span className="label label-primary">
                    {value}
                </span>
            )
        },
        {
            Header: "Channel",
            accessor: "channel",
            width: 150,
            style: { textAlign: 'center' },
            Cell: ({ value }) => (
                <span className="label label-success">
                    {value}
                </span>
            )
        },
        {
            Header: "Sent Date",
            accessor: "sentDate",
            width: 150,
            Cell: ({ value }) =>
                value ? moment(value).format("YYYY-MM-DD") : "-"
        },
        {
            Header: "Recipient",
            accessor: "recipientEmail",
            minWidth: 220,
            Cell: ({ row }) => (
                <span>
                    {row._original.recipientEmail ||
                        row._original.recipientPhone ||
                        "-"}
                </span>
            )
        },
        {
            Header: "Document",
            accessor: "documentAvailable",
            width: 130,
            Cell: ({ value }) =>
                value ? (
                    <span className="label label-success">
                        Available
                    </span>
                ) : (
                    <span className="label label-default">
                        No PDF
                    </span>
                )
        }
    ];

    render() {
            const { selectSchool } = this.props;
            const { activeSchoolYear, selectedSchoolYear, schoolYearOptions, cycleData } = this.state;
            const reportDefaultDate = moment().subtract(activeSchoolYear - selectedSchoolYear, 'years').toDate();
            return (
                <div>
                    <section>
                        <NotificationSystem ref="notificationSystem" />
                        <div className="container">
                            <div className="sectionTitle">
                                <h2>
                                    <span>Verification Reports</span>
                                </h2>
                            </div>           
                        <div className='row' style={{ marginBottom: '15px' }}>
                            <div className="col-sm-12 col-md-4 col-lg-3">
                                <label className="control-label">
                                    School Year
                                </label>

                                <div className="school-year-select-wrapper">
                                    <select
                                        className="form-control form-control-sm"
                                        value={selectedSchoolYear}
                                        onChange={(e) => {
                                            const selectedYear = parseInt(e.target.value);

                                            this.setState(
                                                {
                                                    selectedSchoolYear: selectedYear,
                                                     verifiedSearch: ""
                                                },
                                                () => {
                                                    this.getVerificationCyclesReport(selectedYear, this.props.selectSchool);
                                                    this.getVerificationReportsList(selectedYear,"", this.props.selectSchool);
                                                }
                                            );
                                        }}
                                    >
                                        {schoolYearOptions.map((y) => (
                                            <option key={y} value={y}>
                                                {formatSchoolYear(y)}
                                                {y === activeSchoolYear ? <span className="current-year-badge">
                                            current
                                        </span> : ''}
                                            </option>
                                        ))}
                                    </select>

                                    {selectedSchoolYear === activeSchoolYear && (
                                        <span className="current-year-badge">
                                            current
                                        </span>
                                    )}
                                </div>
                            </div>
                          </div>
                        <div className="row col-md-12" style={{ marginBottom: '15px' }}>
                                <div className="school-year-notification">
                                    <i className="fa fa-info-circle"></i>

                                    <span>
                                        Changing the school year switches the whole area to that
                                        cycle's completed verification process — its reports and
                                        verified-application records — as read-only history.
                                    </span>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: '15px' }}>
                            {/* Cycle */}
                            <div className="col-md-3">
                                <div style={{
                                    backgroundColor: '#eaf2fe',
                                    borderRadius: '10px'
                                }}>
                                    <div className="panel-body">
                                        <div style={{
                                            color: '#777',
                                            textAlign: 'center',
                                            marginBottom: '33px'
                                        }}>
                                            Cycle
                                        </div>
                                        <h4 style={{ textAlign: 'center' }}>
                                            {cycleData ? cycleData.cycle : "NA"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            {/* Completed */}
                            <div className="col-md-3">
                                <div style={{
                                    backgroundColor: '#eaf2fe',
                                    borderRadius: '10px'
                                }}>
                                    <div className="panel-body">
                                        <div style={{
                                            color: '#777',
                                            textAlign: 'center',
                                            marginBottom: '33px'
                                        }}>
                                            Completed
                                        </div>
                                        <h4 style={{ textAlign: 'center' }}>
                                            {cycleData && cycleData.verificationYear
                                                ? `Nov 14, ${cycleData.verificationYear}`
                                                : "NA"
                                            }
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            {/* Sample Size */}
                            <div className="col-md-3">
                                <div style={{
                                    backgroundColor: '#eaf2fe',
                                    borderRadius: '10px'
                                }}>
                                    <div className="panel-body">
                                        <div style={{
                                            color: '#777',
                                            textAlign: 'center',
                                            marginBottom: '33px'
                                        }}>
                                            Sample Size
                                        </div>
                                        <h4 style={{ textAlign: 'center' }}>
                                            {cycleData ? cycleData.sampleSize : "NA"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        {/* Verification Status */}
                        <div className="col-md-3" style={{ marginBottom: '15px' }}>
                            <div style={{
                                backgroundColor: '#eaf2fe',
                                borderRadius: '10px',
                                minHeight: '100px'
                            }}>
                                <div className="panel-body">
                                    <div style={{
                                        color: '#777',
                                        marginBottom: '20px',
                                        textAlign: 'center'
                                    }}>
                                        Verification Status
                                    </div>
                                    <div className="verification-status-summary">
                                        {/* Initial */}
                                        <div className="verification-status-item">
                                            <div style={{
                                                fontSize: '12px',
                                                whiteSpace: 'nowrap'
                                            }}>
                                               <b> Initial - {cycleData ? cycleData.stageCounts.initialCount || 0 : 0}</b>
                                            </div>
                                        </div>
                                        {/* Second Notice */}
                                        <div className="verification-status-item">
                                            <div style={{
                                                fontSize: '12px',
                                                whiteSpace: 'nowrap'
                                            }}>
                                               <b> Second Notice - {cycleData ? cycleData.stageCounts.secondNoticeCount || 0 : 0}</b>
                                            </div>
                                        </div>
                                         {/* Completed */}
                                        <div className="verification-status-item">
                                            <div style={{
                                                fontSize: '12px',
                                                whiteSpace: 'nowrap'
                                            }}>
                                               <b>Completed - {cycleData ? cycleData.stageCounts.completedCount || 0 : 0}</b>
                                            </div>
                                        </div>
                                        {/* Adverse Action */}
                                        <div className="verification-status-item">
                                            <div style={{
                                                fontSize: '12px',
                                                whiteSpace: 'nowrap'
                                            }}>
                                               <b>Adverse Action - {cycleData ? cycleData.stageCounts.adverseActionCount || 0 : 0}</b>
                                            </div>
                                        </div>
                                        {/* Completed */}
                                        {/* <div className="verification-status-item">
                                            <div style={{
                                                fontSize: '12px',
                                                whiteSpace: 'nowrap'
                                            }}>
                                               <b>Completed - {cycleData ? cycleData.stageCounts.completedCount || 0 : 0}</b>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div className="sectionTitle">
                          <h4> <b>Reports :  {cycleData ? cycleData.cycle : null} </b></h4> 
                        </div>   
                        <div className='row' style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {Verification_REPORT_COMPONENTS.map((VerificationReportComponent, i) => (
                                <div className='col-sm-6 col-md-6 col-lg-6' key={i}>
                                    <VerificationReportComponent
                                        key={`report-${i}-${selectedSchoolYear}`}
                                        {...this.props}
                                        {...this}
                                        selectedSchoolYear={selectedSchoolYear}
                                        reportDefaultDate={reportDefaultDate}
                                        selectedSchoolId={this.props.selectSchool}
                                    />
                                </div>
                            ))}
                        </div>  
                       <div className="verified-record-section">
                            <div className="verified-record-title">
                               <h5> <b> VERIFIED APPLICATION RECORDS — DISTRICT : {cycleData ? cycleData.cycle : null}</b></h5>
                            </div>
                            <div style={{ position: 'relative', width: '200px', marginBottom: '10px' }}>
                                <i
                                    className="fa fa-search"
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: '#999',
                                        zIndex: 1
                                    }}
                                />
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Search guardian, student, or application..."
                                    style={{
                                        width: '200px',
                                        paddingLeft: '30px'
                                    }}
                                    value={this.state.verifiedSearch}
                                    onChange={this.handleVerifiedSearch}
                                />
                            </div>
                            <ReactTable
                                data={this.state.verifiedApplications || []}
                                columns={this.getVerifiedApplicationColumns()}
                                defaultPageSize={5}
                                pageSizeOptions={[5, 10, 20]}
                                showPagination={true}
                                sortable={false}
                                filterable={false}
                                showPageSizeOptions={true}
                                minRows={0}
                                className= "-striped -highlight"
                            />
                        </div>
                     </div> 
    <Modal
        show={this.state.showVerificationDetailsModal}
        onHide={this.closeVerificationDetailsModal}
        bsSize="lg"
        dialogClassName="verification-details-modal"
    >
        <Modal.Header closeButton>
            <Modal.Title>
                <i className="fa fa-file-text-o" /> <b>Verification Details</b>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {/* Documents */}
        <div className="verification-detail-section">
            <div className="verification-detail-header">
                <h4>
                    <i className="fa fa-folder-open-o" />
                    {" "}Documents
                </h4>
            </div>
            <ReactTable
                data={this.state.verificationDetails.documents}
                columns={this.getDocumentColumns()}
                defaultPageSize={5}
                pageSizeOptions={[5, 10]}
                minRows={0}
                sortable={false}
                filterable={false}
                showPagination={true}
                className="-striped -highlight"
            />
        </div>
        {/* History */}
        <div className="verification-detail-section">
            <div className="verification-detail-header">
                <h4>
                    <i className="fa fa-history" />
                    {" "}Verification History
                </h4>
            </div>
            <ReactTable
                data={this.state.verificationDetails.history}
                columns={this.getHistoryColumns()}
                defaultPageSize={5}
                pageSizeOptions={[5, 10]}
                minRows={0}
                sortable={false}
                filterable={false}
                showPagination={true}
                className="-striped -highlight"
            />
        </div>
        {/* Annotations */}
        <div className="verification-detail-section">
            <div className="verification-detail-header">
                <h4>
                    <i className="fa fa-sticky-note-o" />
                    {" "}Annotations
                </h4>
            </div>
            <ReactTable
                data={this.state.verificationDetails.annotations}
                columns={this.getAnnotationColumns()}
                defaultPageSize={5}
                pageSizeOptions={[5, 10]}
                minRows={0}
                sortable={false}
                filterable={false}
                showPagination={true}
                className="-striped -highlight"
            />
        </div>
        {/* Correspondence */}
        <div className="verification-detail-section">
            <div className="verification-detail-header">
                <h4>
                    <i className="fa fa-envelope-o" />
                    {" "}Correspondence
                </h4>
            </div>
            <ReactTable
                data={this.state.verificationDetails.correspondence}
                columns={this.getCorrespondenceColumns()}
                defaultPageSize={5}
                pageSizeOptions={[5, 10]}
                minRows={0}
                sortable={false}
                filterable={false}
                showPagination={true}
                className="-striped -highlight"
            />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
            type="button"
            className="btn btn-default"
            onClick={this.closeVerificationDetailsModal}
        >
            <i className="fa fa-times" /> Close
        </button>
    </Modal.Footer>
  </Modal>           
</section>
</div>       
 );
 }
}
export default VerificationReports;


// WEBPACK FOOTER //
// ./src/components/District/VerificationReport/index.js